import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Download, ExternalLink, FileCheck2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";

const CU_NAME = "Proposed Trillion Dollar Spending Power Federal Credit Union";

export default function MilestoneLetter() {
  const [meta, setMeta] = useState(null);
  const [url, setUrl] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let objectUrl;
    api.get("/milestone/letter")
      .then(async (r) => {
        setMeta(r.data);
        if (!r.data.available) return;
        const f = await api.get("/milestone/letter/file", { responseType: "blob" });
        objectUrl = URL.createObjectURL(f.data);
        setUrl(objectUrl);
      })
      .catch((e) => setError(formatApiError(e.response?.data?.detail) || "The letter couldn't be loaded."));
    return () => objectUrl && URL.revokeObjectURL(objectUrl);
  }, []);

  useEffect(() => { document.title = "FOM Pre-Approval Letter — Black Dollars United"; }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 sm:px-10 py-14" data-testid="milestone-letter-page">
      <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-bdu-cream/60 hover:text-bdu-gold" data-testid="milestone-letter-back">
        <ArrowLeft size={14} /> Back to home
      </Link>
      <div className="mt-8 flex flex-wrap items-end justify-between gap-6">
        <div>
          <div className="label-eyebrow flex items-center gap-2"><FileCheck2 size={13} className="text-bdu-gold" /> Phase I · Complete</div>
          <h1 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl text-bdu-cream leading-tight">
            {meta?.title || "Field of Membership (FOM) Pre-Approval Letter"}
          </h1>
          <p className="mt-3 text-sm text-bdu-cream/60">{CU_NAME} · {meta?.letter_date || "October 21, 2026"}</p>
        </div>
        {url && (
          <div className="flex flex-wrap gap-3">
            <a href={url} download={meta.filename} className="btn-gold inline-flex items-center gap-2" data-testid="milestone-letter-download">
              <Download size={16} /> Download
            </a>
            <a href={url} target="_blank" rel="noopener noreferrer" className="btn-ghost inline-flex items-center gap-2" data-testid="milestone-letter-fullscreen">
              <ExternalLink size={16} /> Full screen
            </a>
          </div>
        )}
      </div>

      <div className="mt-10 border border-bdu-gold/25 bg-bdu-surface2" data-testid="milestone-letter-viewer">
        {error && <div className="p-10 text-sm text-red-300" data-testid="milestone-letter-error">{error}</div>}
        {!error && meta && !meta.available && (
          <div className="p-10 text-sm text-bdu-cream/60 italic" data-testid="milestone-letter-pending">The letter will be posted here soon.</div>
        )}
        {!error && (!meta || (meta.available && !url)) && <div className="p-10 text-sm text-bdu-cream/50">Loading letter…</div>}
        {url && meta.file_type === "pdf" && (
          <iframe src={url} title={meta.title} className="w-full h-[80vh] bg-white" data-testid="milestone-letter-pdf" />
        )}
        {url && meta.file_type === "image" && (
          <img src={url} alt={meta.title} className="w-full h-auto bg-white" data-testid="milestone-letter-image" />
        )}
      </div>

      <p className="mt-6 text-xs text-bdu-cream/45 leading-relaxed max-w-3xl">
        Shared with signed-in members of Black Dollars United. The {CU_NAME} is proposed, pending NCUA charter approval.
      </p>
    </div>
  );
}
